export const compressBynderUrl = (url?: string, width?: number, height?: number) => {
  if (url && url.includes('https://content.skyscnr.com')) {
    const compressedUrl = new URL(url);
    compressedUrl.searchParams.set('imbypass', 'false');
    compressedUrl.searchParams.set('resize', `${width}px:${height}px`);

    return compressedUrl.href;
  }

  return url;
};

const EFS_GRAPHIC_PROMO_MOBILE_RESIZE = {
  // this width corresponds to the bpk-breakpoint-small-tablet() mixin
  // that is used in <GraphicPromoCard /> for displaying the mobile image
  // https://backpack.github.io/sassdoc/#breakpoints-variable-bpk-breakpoint-small-tablet
  // 48 rem = 768px
  WIDTH: 768,
  HEIGHT: 1024,
};

export const compressGraphicPromoUrl = (url?: string) =>
  compressBynderUrl(
    url,
    EFS_GRAPHIC_PROMO_MOBILE_RESIZE.WIDTH,
    EFS_GRAPHIC_PROMO_MOBILE_RESIZE.HEIGHT,
  );
